export const normalizeConferenceLanguageKey = (languageKey) => {
  if (typeof languageKey !== "string") {
    return "";
  }

  return languageKey.trim().toLowerCase().replace(/_/g, "-");
};
